/* Progressive enhancement: content and shopping remain usable without motion. */
(()=>{
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const active=new Set();
 function animate(node,frames,options={}){
  if(!node||reduced.matches||!node.animate)return;
  const animation=node.animate(frames,{duration:320,easing:'cubic-bezier(.22,.61,.36,1)',...options});
  active.add(animation);animation.finished.catch(()=>{}).finally(()=>active.delete(animation));
 }
 reduced.addEventListener('change',()=>{if(reduced.matches)active.forEach(a=>a.cancel())});
 const reveal=node=>animate(node,[{opacity:.35,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:520});
 const observed=new WeakSet();
 const observer='IntersectionObserver'in window?new IntersectionObserver(entries=>entries.forEach(entry=>{
  if(entry.isIntersecting){observer.unobserve(entry.target);reveal(entry.target)}
 }),{threshold:.08}):null;
 function watchSections(){
  document.querySelectorAll('.section-head,.directory-card,.quality,.story,.pairing-grid,.help-section').forEach(node=>{
   if(observed.has(node))return;observed.add(node);
   // Never hide content, and never transform the sticky product layout.
   if(observer&&node.getBoundingClientRect().top>innerHeight)observer.observe(node);
  });
 }
 watchSections();
 new MutationObserver(watchSections).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
 document.addEventListener('click',event=>{
  const control=event.target.closest('button,.button');
  if(control&&!control.disabled)animate(control,[{scale:'1'},{scale:'.96',offset:.35},{scale:'1'}],{duration:220});
 });
 document.querySelectorAll('dialog').forEach(dialog=>new MutationObserver(()=>{
  if(dialog.open)animate(dialog,[{opacity:0,translate:dialog.id==='cart'?'24px 0':'0 12px'},{opacity:1,translate:'0 0'}]);
 }).observe(dialog,{attributes:true,attributeFilter:['open']}));
 document.querySelectorAll('[role="tabpanel"]').forEach(panel=>new MutationObserver(()=>{
  if(!panel.hidden)reveal(panel);
 }).observe(panel,{attributes:true,attributeFilter:['hidden']}));
 document.addEventListener('toggle',event=>{
  if(event.target.matches('details[open]'))Array.from(event.target.children).filter(n=>n.tagName!=='SUMMARY').forEach(reveal);
 },true);
})();
